import "./Tabs.css";

export default function Tabs({ tabs, activeTab, onChange }) {
  return (
    <section className="tabs-section">
      <div className="tabs-container">
        <div className="tabs-list">
          {tabs.map((tab) => {
            const isActive = tab.value === activeTab;

            return (
              <button
                key={tab.value}
                onClick={() => onChange(tab.value)}
                className={`tabs-button ${
                  isActive
                    ? "tabs-button--active"
                    : "tabs-button--inactive"
                }`}
              >
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
